import Modal from "flarum/common/components/Modal";
import Link from "flarum/common/components/Link";
import username from "flarum/common/helpers/username";
import Avatar from "flarum/common/components/Avatar";
import app from "flarum/forum/app";
export default class PostDiscussionViewsModal extends Modal {
  className() {
    return "Modal--small";
  }
  title() {
    return app.translator.trans("michaelbelgium-discussion-views.forum.post.modal_title_text");
  }
  content() {
    const views = this.attrs.post.discussion().uniqueViews();
    const names = views.map(view => {
      const user = view.user();
      return m("li", null, m(Link, {
        href: app.route.user(user)
      }, m(Avatar, {
        user: user
      }), username(user)));
    });
    return m("div", {
      className: "Modal-body"
    }, m("ul", {
      className: "PostLikesModal-list"
    }, names));
  }
}
flarum.reg.add('michaelbelgium-discussion-views', 'forum/components/PostDiscussionViewsModal', PostDiscussionViewsModal);